// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"48ffa12c","347":"3ceb3e36","787":"6c32b176"}[chunkId] + ".chunk.js";
};